import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { Container } from '../Container/Container.js';

const Split = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    children,
    className = '',
    ...rest
  } = _ref;
  const childrenToRender = React__default.Children.toArray(children).slice(0, 2);
  return /*#__PURE__*/React__default.createElement("section", {
    className: `${className} b-split`,
    ref: ref,
    "data-testid": "split"
  }, /*#__PURE__*/React__default.createElement(Container, _extends({
    flex: true
  }, rest), childrenToRender));
});
Split.displayName = 'Split';

export { Split };
